@import './cms-market-module.scss';

:host {
  background: #666;
  background: linear-gradient(135deg,
      #666 74%,
      #fa9d26 74%,
      #fa9d26 93%,
      #666 93%,
      #666 94%);
  filter: progid:dximagetransform.microsoft.gradient(startColorstr='#666666', endColorstr='#666666', GradientType=1);
}